export default __webpack_public_path__ + "static/media/search.f60f2111.svg";